import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Mixpanel } from '../../redux/Mixpanel';

import {
    Col,
    Row
} from 'reactstrap';
import { colorTheme, OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';

import {
    fetchTransactions,
    showLoading,
    downloadTenantTransactionsReport,
    sendPaymentReminder,
    fetchOptions,
    sendPaymentReceipt,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    deletePayments,
    showCustomMessage,
    sendInvoice,
    uploadBulkTransactions,
    deleteInvoices,
    sendTenantStatement,
    fetchCurrency,
    fetchUser,
    fetchPayments,
    fetchInvoices
} from '../../redux/actions';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware/properties';
import store from '../../redux/store';
import dayjs from 'dayjs';
import PaymentForm from '../Forms/PaymentForm';
import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonFabList, IonFooter, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonList, IonMenuButton, IonModal, IonPage, IonSearchbar, IonTitle, IonToolbar } from '@ionic/react';
import { add, cash, send, mailOutline, download, receiptOutline, arrowBack } from 'ionicons/icons';
import { Card } from '@tremor/react';
import TenantTransactionsListItem from './TenantTransactionsListItem';
import TenantTransactionsSummaryCard from './TenantTransactionsSummary';
import InvoiceForm from '../Forms/InvoiceForm';
import { Capacitor } from '@capacitor/core';
import * as PermChecker from '../../utils/PermUtils';
import { ReallocateTenantPaymentForm } from '../Forms';

const TRANSACTIONS_PAGE = "transactionsPage";
const PAYMENT_FORM_PAGE = "paymentForm";
const INVOICE_FORM_PAGE = "invoiceForm";
const MESSAGE_FORM_PAGE = "messageForm";
const REALLOCATE_PAYMENT_FORM_PAGE = "reallocatePaymentForm";

const mapStateToProps = state => {
    return {
        tenants: state.tenants,
        financials: state.financials,
        properties: state.properties,
        units: state.units,
        user: state.user,
        payments: state.payments,
        invoices: state.invoices,
        currency: state.currency,
        options: state.options
    };
}

const mapDispatchToProps = {
    fetchTransactions,
    fetchUser,
    showLoading,
    downloadTenantTransactionsReport,
    sendPaymentReminder,
    fetchOptions,
    sendPaymentReceipt,
    deletePayments,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    showCustomMessage,
    sendInvoice,
    uploadBulkTransactions,
    deleteInvoices,
    sendTenantStatement,
    fetchCurrency,
    fetchPayments,
    fetchInvoices
}


class TenantTransactions extends React.Component{

    constructor(props){
        super(props);

        this.handleClosePaymentForm = this.handleClosePaymentForm.bind(this);
        this.handleCloseInvoiceForm = this.handleCloseInvoiceForm.bind(this);
        this.handleCloseAssignTenantModal = this.handleCloseAssignTenantModal.bind(this);

        let tenant = {};

        if(this.props.history && this.props.history.location && this.props.history.location.state){
            const locationState = this.props.history.location.state;
            tenant = locationState.tenant? locationState.tenant : {};
        }
        if(!(tenant && tenant.tenantId)){
            this.props.history.push(UNIFORM_RESOURCE_LOCATORS.tenants)
        }
        let tenantDetails = {}
        if(tenant){
            tenantDetails = {
                tenantId: tenant.tenantId,
                firstName: tenant.firstName,
                lastName: tenant.lastName,
                unitId: tenant.unitId,
                propertyId: tenant.propertyId,
                archived: tenant.archived
            }
        }

        // let tenantId = props.tenant.tenantId;
        let deposit = 0;
        if(tenant?.deposits.length > 0){
            for(let d of tenant.deposits){
                deposit += d.amountPaid;
            }
        }
        this.state = {
            tenant,
            tenantDetails,  // for transactions eg. invoices and payments
            deposit,
            transactions:[],
            startDate: null,
            endDate: null,
            focusedDateInput: null,
            selectedTransactions: [],
            currentPage: 1,
            pagesCount: 1,
            postsPerPage: 10,
            offset: "",
            page: TRANSACTIONS_PAGE,
            invoiceId: "",
            paymentId: "",
            userAllPerms: {}
        };

    }

    async fetchInitialData(){
        this.props.showLoading(true);
        if(_.isEmpty(this.props.currency)){
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
        if (_.isEmpty(this.props.properties)){
            await store.dispatch(fetchPropertiesUnitsTenants);
        }
        if(_.isEmpty(this.props.options)){
            this.props.showLoading(true);
            this.props.fetchOptions();
        }
        if(_.isEmpty(this.props.user)){
            this.props.showLoading(true);
            await this.props.fetchUser();
        }
        if(_.isEmpty(this.props.payments)){
            this.props.showLoading(true);
            await this.props.fetchPayments();
        }
        if(_.isEmpty(this.props.invoices)){
            this.props.showLoading(true);
            await this.props.fetchInvoices();
        }
        this.props.showLoading(false);
        await this.fetchTenantTransactions();
    }


    async componentDidMount(){
        await this.fetchInitialData();
        const hasAllInvoicePerm = PermChecker.checkUserHasPermission(PermChecker.INVOICE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllMsgPerm = PermChecker.checkUserHasPermission(PermChecker.MESSAGE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllPaymentPerm = PermChecker.checkUserHasPermission(PermChecker.PAYMENT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        this.setState({
            userAllPerms: {
                invoice: hasAllInvoicePerm,
                message: hasAllMsgPerm,
                payment: hasAllPaymentPerm
            }
        });
    }

    async fetchTenantTransactions(){
        this.props.showLoading(true);
        const action = await this.props.fetchTransactions({
            tenantId: this.state.tenant.tenantId,
            startDate: this.state.startDate,
            endDate: this.state.endDate
        });
        this.props.showLoading(false);
        const transactions = action.payload.transactions;
        this.setState({
            transactions,
            selectedTransactions: this.getTransactionsSlice(transactions, 1),
            pagesCount: Math.ceil(transactions.length/this.state.postsPerPage)
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.page === TRANSACTIONS_PAGE &&
            (this.props.payments !== prevProps.payments || this.props.invoices !== prevProps.invoices)) {
            this.reloadTransactionsPage();
        }

        const currentTenant = this.props.history?.location?.state?.tenant;

        if (
            currentTenant?.tenantId &&
            currentTenant.tenantId !== this.state.tenant?.tenantId
        ) {
            const deposit = currentTenant.deposits?.reduce((sum, d) => sum + d.amountPaid, 0) || 0;

            this.setState({
                tenant: currentTenant,
                tenantDetails: {
                    tenantId: currentTenant.tenantId,
                    firstName: currentTenant.firstName,
                    lastName: currentTenant.lastName,
                    unitId: currentTenant.unitId,
                    propertyId: currentTenant.propertyId,
                    archived: currentTenant.archived
                },
                deposit
            }, () => {
                this.fetchTenantTransactions();
            });
        }
    }

    getTransactionsSlice(transactions, currentPage){
        let indexOfLastPost = currentPage * this.state.postsPerPage;
        let indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        let slice = transactions.slice(indexOfFirstPost, indexOfLastPost);
        return slice
    }

    // renderDateFilters(){
    //     return (
    //         <Col>
    //             <FormGroup>
    //                 <DateRangePicker
    //                     showClearDates
    //                     numberOfMonths={1}
    //                     isOutsideRange={() => false}
    //                     small={true}
    //                     startDate={this.state.startDate} // dayjsPropTypes.dayjsObj or null,
    //                     startDateId="startDateInput" // PropTypes.string.isRequired,
    //                     endDate={this.state.endDate} // dayjsPropTypes.dayjsObj or null,
    //                     endDateId="endDateInput" // PropTypes.string.isRequired,
    //                     onDatesChange={({ startDate, endDate }) => {
    //                         this.setState({ startDate, endDate });
    //                     }} // PropTypes.func.isRequired,
    //                     focusedInput={this.state.focusedDateInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
    //                     onFocusChange={focusedDateInput => this.setState({ focusedDateInput })} // PropTypes.func.isRequired,
    //                 />
    //             </FormGroup>
    //         </Col>
    //     );
    // }

    handleDownloadFile(outputFormat, event) {
        event.preventDefault();
        const tenantId = this.state.tenant.tenantId;
        this.props.showLoading(true);

        
        this.props.downloadTenantTransactionsReport({ tenantId, outputFormat });
        Mixpanel.track(`Tenants Transactions tab: Download ${outputFormat}`);
        
    }

    onClickSendMessage(event){
        event.preventDefault();
        this.setState({ page: MESSAGE_FORM_PAGE });
        Mixpanel.track("Tenants Transactions tab: send message btn");
    }

    onClickSendPaymentReminder(event){
        event.preventDefault();
        this.props.showLoading(true);
        this.props.sendPaymentReminder({tenantIds: [this.state.tenant.tenantId]});
        Mixpanel.track("Tenants Transactions tab: send payment reminder btn");
    }

    onClickSendTenantStatement(event){
        event.preventDefault();
        this.props.showLoading(true);
        this.props.sendTenantStatement({tenantIds: [this.state.tenant.tenantId]});
        Mixpanel.track("Tenants Transactions tab: send tenant statement");
    }

    handleSelectTransaction(transactionId, transactionType, event){
        event.preventDefault();
        if(transactionType.toLowerCase() == "payment"){
            this.setState({
                page: PAYMENT_FORM_PAGE,
                paymentId: transactionId
            });
        }else if(transactionType.toLowerCase() == "invoice"){
            this.setState({
                page: INVOICE_FORM_PAGE,
                invoiceId: transactionId
            });
        }
    }

    async reloadTransactionsPage(){
        this.setState({
            page: TRANSACTIONS_PAGE,
            paymentId: "",
            invoiceId: ""
        });
        await this.fetchInitialData();
    }

    async handleSelectPaymentAction(key, value, event){
        if (key === 'edit'){
            this.setState({paymentId: value, tenantDetails: this.state.tenantDetails, page: PAYMENT_FORM_PAGE});
            Mixpanel.track("Tenants tab: quick actions edit payment");
        } else if(key === 'sendReceipt'){
            this.props.showLoading(true);
            this.props.sendPaymentReceipt({paymentIds: [value]});
            Mixpanel.track("Tenants tab: quick actions send receipt");
        } else if(key === 'downloadReceipt'){
            this.props.showLoading(true);
            this.props.downloadInvoiceOrReceipt('receipt', value);
        } else if(key === 'reallocate'){
            this.setState({page: REALLOCATE_PAYMENT_FORM_PAGE, paymentId: value});
        } else if(key == 'delete'){
            if(confirm("Are you sure you want to delete this payment?")){
                this.props.showLoading(true);
                const paymentIds=[value];
                await this.props.deletePayments(paymentIds);
                await this.reloadTransactionsPage()
                Mixpanel.track("Tenants page: delete btn");
            }
        }
    }

    async handleSelectInvoiceAction(key, value) {
        if (key === 'edit') {
            this.setState({
                invoiceId: value,
                tenantDetails: this.state.tenantDetails,
                page: INVOICE_FORM_PAGE
            });
            Mixpanel.track("Tenants tab: quick actions edit invoice");
        } else if (key === 'sendInvoice') {
            this.props.showLoading(true);
            this.props.sendInvoice({ invoiceIds: [value] });
            Mixpanel.track("Tenants tab: quick actions send message");
        } else if(key === 'downloadInvoice'){
            this.props.showLoading(true);
            this.props.downloadInvoiceOrReceipt('invoice', value);
        } else if (key == "delete"){
            if(confirm("Are you sure you want to delete this invoice?")){
                this.props.showLoading(true);
            await this.props.deleteInvoices([value]);
                await this.reloadTransactionsPage()
                Mixpanel.track("Tenants page: delete btn");
            }
        }
    }

    async handleClosePaymentForm(){
        await this.reloadTransactionsPage();
        this.setState({page: TRANSACTIONS_PAGE, paymentId: "" });
    }

    async handleCloseInvoiceForm(){
        await this.reloadTransactionsPage();
        this.setState({page: TRANSACTIONS_PAGE, invoiceId: "" });
    }

    async handleCloseAssignTenantModal(){
        await this.reloadTransactionsPage();
        this.setState({page: TRANSACTIONS_PAGE, paymentId: "" });
    }

    async handleBackButton(event) {
        event.preventDefault();
        if (this.state.page === TRANSACTIONS_PAGE) {
            this.props.history.goBack();
        } else {
            await this.reloadTransactionsPage();
        }
    }

    async filterTenantTransactions(){
        let params = this.getQueryParams();
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchTenants(params);
        let offset = this.state.offset;
        if(payloadResult){
            offset = payloadResult.offset;
        }

        this.setState((state) => {
            const selectedTenants = this.getTenantsOrder();
            return {
                selectedTenants,
                offset
            }
        });
    }

    renderReallocatePaymentForm(){
        return (
            <IonModal isOpen={this.state.page === REALLOCATE_PAYMENT_FORM_PAGE} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Re-allocate Payment</IonTitle>
                        <IonButtons slot="end">
                        <IonButton onClick={this.handleCloseAssignTenantModal}>
                            Close
                        </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <ReallocateTenantPaymentForm
                    paymentId={this.state.paymentId}
                    amount={this.state.transactions.find(t => t.id === this.state.paymentId).moneyPaid}
                />
                </IonContent>
            </IonModal>
        );
    }

    // renderReallocatePaymentModal(modalTarget){
    //     return (
    //         <React.Fragment>
    //             <p>
    //                 <input
    //                     type="button"
    //                     style={{display:'none'}}
    //                     ref={this.reallocatePaymentRef}
    //                     id={modalTarget}
    //                 />
    //             </p>
    //             <ReallocatePaymentForm
    //                 modalTarget={modalTarget}
    //                 dataName={"tenants"}
    //                 paymentId={this.state.paymentId}
    //                 unassignedFilter={this.state.unassigned}
    //                 onSuccessCallBack={() => this.reloadTransactionsPage()}
    //             />
    //         </React.Fragment>);
    // }

    // renderFilters(){
    //     return (
    //         <React.Fragment>
    //             {/* Date Filter */}
    //             <Nav vertical className="mb-3">
    //                 <NavItem className="px-1 mb-1">
    //                     <NavLink href="#" className="small d-flex px-1">
    //                         <span className="h6 fw-300">
    //                             Date
    //                         </span>
    //                         <i className="fa fa-angle-down align-self-center ml-auto"></i>
    //                     </NavLink>
    //                 </NavItem>

    //                 <NavItem className="d-flex px-2">
    //                     <DateRangePicker
    //                         isOutsideRange={() => false}
    //                         small={true}
    //                         startDate={this.state.startDate} // dayjsPropTypes.dayjsObj or null,
    //                         startDateId="startDateInput" // PropTypes.string.isRequired,
    //                         endDate={this.state.endDate} // dayjsPropTypes.dayjsObj or null,
    //                         endDateId="endDateInput" // PropTypes.string.isRequired,
    //                         onDatesChange={({ startDate, endDate }) => {
    //                             this.setState({ startDate, endDate });
    //                         }} // PropTypes.func.isRequired,
    //                         focusedInput={this.state.focusedDateInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
    //                         onFocusChange={focusedDateInput => this.setState({ focusedDateInput })} // PropTypes.func.isRequired,
    //                     />
    //                 </NavItem>
    //             </Nav>

    //         </React.Fragment>
    //     );
    // }

    renderInvoiceForm(){
        return (
            <IonModal isOpen={this.state.page === INVOICE_FORM_PAGE} onDidDismiss={this.handleCloseInvoiceForm}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Invoice Form</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={this.handleCloseInvoiceForm}>Close</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <InvoiceForm
                    tenantDetails={this.state.tenant}
                    invoiceId={this.state.invoiceId}
                />
            </IonContent>
        </IonModal>
    );}

    renderPaymentForm(){
        return (
            <IonModal isOpen={this.state.page === PAYMENT_FORM_PAGE} onDidDismiss={this.handleClosePaymentForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Payment Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleClosePaymentForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <PaymentForm
                        tenantDetails={this.state.tenant}
                        paymentId={this.state.paymentId}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderBackButton() {
        return (
            <IonButton className="mx-2"
                style={{ borderColor: colorTheme["primary"]["700"], color: 'white' }}
                data-testid="tenantTransactionsBackBtn"
                onClick={this.handleBackButton.bind(this)}
            >
                <IonIcon icon={arrowBack} slot="start" />
                Back
            </IonButton>
        );
    }

    renderTenantsTransactionsTable(){
        let displayButton = true;
        displayButton =  Capacitor.getPlatform() === 'web';

        return(
            <React.Fragment>
                <IonHeader className='ion-no-border'>
                    {displayButton && (<Row>
                        <Col style={{ display: "flex", justifyContent: "start", margin: "1em 0 0 1em"}}>
                            {this.renderBackButton()}
                        </Col>
                    </Row>)}
                    <Row className='mx-2 mt-3 pb-1 mb-3 border-bottom'>
                        <Col xs={6} md={5}>
                            <TenantTransactionsSummaryCard
                                header={"Total Deposit"}
                                body={String(this.state.deposit)}
                                // footer={`(${this.props.currency.customerCurrency})`}
                            />
                        </Col>
                        <Col xs={6} md={5}>
                            <TenantTransactionsSummaryCard
                                header={"Current Balance"}
                                body={String(this.state.transactions.length!==0 ? this.state.transactions[0].endOfDayBalance : this.state.tenant?.accountBalance)}
                                // footer={`(${this.props.currency.customerCurrency})`}
                            />
                        </Col>
                    </Row>
                {/* <Row className='mr-1'> //Removed search bar cause the backend currently doesn't have search text filter
                    <Col className='mr-0 pr-0' xs={10} md={10}>
                        <IonSearchbar
                            onIonInput={(e) => {
                                this.setState({ searchText: e.detail.value });
                            }}
                            onIonChange={async (e) => {
                                this.setState({ searchText: e.detail.value });
                                await this.filterTenantTransactions();
                            }}
                        />
                    </Col>
                    <Col className='pr-1' xs={2} md={1}>
                        <IonButton
                            onClick={ () => { this.setState({tab: PAGE_FILTERS}) }}
                            fill="clear"
                        >
                            <IonIcon size="large" aria-hidden="true"
                            icon={filter}
                            />
                        </IonButton>
                    </Col>
                </Row> */}
                    <Row className='border-bottom py-1'>
                        <Col className='ml-4' xs={11} md={10}>
                            <Row className='align-items-end'>
                                <Col xs={5} sm={6}>
                                    <strong>Date</strong>
                                </Col>
                                <Col xs={3} sm={3}>
                                    <strong>Amount</strong>
                                </Col>
                                <Col className='px-0 mx-0 flex justify-content-end justify-content-md-start' xs={4} sm={3}>
                                <strong>Running Balance</strong>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={2} md={2}>
                        </Col>
                    </Row>

                </IonHeader>
                <div>
                <Card style={{margin: 0, padding: 0}}>
                <IonList style={{margin: 0, padding: 0}}>
                    {this.state.transactions.map((transaction, index) => {
                        let date = null;
                        let transactionId = "";
                        let description = "";
                        let moneyDue = "";
                        let moneyPaid = 0;
                        let balance = "";
                        let shortDescription = "";
                        let itemType = "";
                        let amount = "";
                        let dateString = "";
                        let message = "";
                        if(transaction){
                            date = dayjs(transaction.date);
                            dateString = date.format('YYYY/MM/DD');
                            transactionId = transaction.id;
                            description = transaction.description;
                            moneyDue = transaction.moneyDue;
                            moneyPaid = transaction.moneyPaid;
                            balance = transaction.endOfDayBalance;
                            shortDescription = transaction.shortDescription;
                            itemType = transaction.itemType;
                            amount = transaction.amount;
                            message = transaction.message;
                        }
                        return (
                            <TenantTransactionsListItem
                                key={transactionId || index}
                                date={dateString}
                                transactionId={transactionId}
                                description={description}
                                moneyDue={moneyDue}
                                moneyPaid={moneyPaid}
                                balance={balance}
                                shortDescription={shortDescription}
                                itemType={itemType}
                                amount={amount}
                                message={message}
                                userAllPerms={this.state.userAllPerms}
                                showDetails={false}
                                options={this.props.options}
                                handleSelectTransaction={itemType === "Payment" ? this.handleSelectPaymentAction.bind(this) : this.handleSelectInvoiceAction.bind(this)}
                            />
                        )
                    })}
                    </IonList>

                    <IonInfiniteScroll
                        threshold='100px'
                        onIonInfinite={async (ev) => {
                            ev.target.complete();
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </Card>
                </div>
            </React.Fragment>
        )
    }

    renderTransactionsPage = () => {
        return(
            <div>
                {this.renderTenantsTransactionsTable()}
            </div>
        )
    }

    // renderMessageForm(){
    //     return (<Row>
    //         <Col md={9}>
    //             <SendMessageForm
    //                 tenant={this.state.tenant}/>
    //         </Col>
    //     </Row>);
    // }

    render(){
        let tenantName = "";
        let propertyName = "";
        let unitName = "";
        tenantName = this.state.tenant?.firstName + " " + this.state.tenant?.lastName;
        propertyName = this.props.properties[this.state.tenant?.propertyId]?.propertyName;
        unitName = this.props.units[this.state.tenant?.unitId]?.unitName;
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>{this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Transactions</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    {this.state.page == TRANSACTIONS_PAGE && !_.isEmpty(this.props.properties) && this.renderTransactionsPage()}
                    {this.state.page == INVOICE_FORM_PAGE && this.renderInvoiceForm()}
                    {this.state.page == PAYMENT_FORM_PAGE && this.renderPaymentForm()}
                    {this.state.page == REALLOCATE_PAYMENT_FORM_PAGE && this.renderReallocatePaymentForm()}
                    {/* {(this.state.page == MESSAGE_FORM_PAGE) && this.renderMessageForm()} */}

                    <IonFab className='ion-fab' id='tenant-transactions-ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                        <IonFabButton aria-label="Actions">
                            <IonIcon icon={add} />
                        </IonFabButton>

                        <IonFabList side="top">
                            {this.state.userAllPerms.payment &&
                            <IonFabButton
                                id='add-payment-fab-btn'
                                onClick={() => this.setState({page: PAYMENT_FORM_PAGE})}
                                data-desc="Add New Payment"
                            >
                                <IonIcon icon={cash}></IonIcon>
                            </IonFabButton>}
                             {this.state.userAllPerms.invoice &&
                            <IonFabButton
                                id='add-invoice-fab-btn'
                                onClick={() => this.setState({page: INVOICE_FORM_PAGE})}
                                data-desc="Add New Invoice"
                            >
                                <IonIcon icon={receiptOutline}></IonIcon>
                            </IonFabButton>}
                            {this.state.userAllPerms.message &&( <>
                            <IonFabButton
                                id='send-payment-reminder-fab-btn'
                                onClick={this.onClickSendPaymentReminder.bind(this)}
                                data-desc="Send Balance Reminder"
                            >
                                <IonIcon icon={send}></IonIcon>
                            </IonFabButton>

                            {/* <IonFabButton
                                onClick={this.onClickSendMessage.bind(this)}
                                data-desc="Send Custom Message"
                            >
                                <IonIcon icon={send}></IonIcon>
                            </IonFabButton> */}

                            <IonFabButton
                                id='send-tenant-statement-sms-fab-btn'
                                onClick={this.onClickSendTenantStatement.bind(this)}
                                data-desc={`Send ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Statement`}
                            >
                                <IonIcon icon={send}></IonIcon>
                            </IonFabButton></>)}

                            <IonFabButton
                                id='download-tenant-statement-fab-btn'
                                onClick={this.handleDownloadFile.bind(this, "pdf")}
                                data-desc={`Download ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Statement (PDF)`}
                            >
                                <IonIcon icon={download}></IonIcon>
                            </IonFabButton>

                            <IonFabButton
                                id='download-tenant-statement-csv-fab-btn'
                                onClick={this.handleDownloadFile.bind(this, "csv")}
                                data-desc={`Download ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} Statement (CSV)`}
                            >
                                <IonIcon icon={download}></IonIcon>
                            </IonFabButton>
                        </IonFabList>
                        </IonFab>
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle id='tenant-name-ion-title'>
                            {tenantName} ({propertyName} {unitName})
                        </IonTitle>
                    </IonToolbar>
                </IonFooter>

            </IonPage>);
    }
}


export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TenantTransactions));
